import { BluetoothSettingsIcon } from './BluetoothSettingsIcon';

/**
 * author: Google
 * id E5DEA4AB-58E1-45CF-81EF-1A98594C5884
 * name bluetooth-settings
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bluetooth-settings.svg
 * tags
 * - Settings 
 */
export const SettingsBluetoothIcon = BluetoothSettingsIcon;
export default SettingsBluetoothIcon